export const API_TURK_SETTINGS = 'core/turk/settings';
export const API_TURK_STATS = 'core/turk/stats';
export const API_TURK_SETTINGS_UPDATE = 'admins/admin-panel/turk/settings';
export const API_TURK_CLEAR_READINGS = 'core/turk/readings/clear';
export const API_TURK_PROFILE = 'core/turk/profile';
